import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { MyContext } from '../pages/context/UserProvider';
import { FaWhatsapp, FaBars, FaTimes, FaUser, FaRegCommentDots, FaShoppingCart, FaSortDown, FaSortUp, FaCommentAlt, FaSearch, FaPlus, FaAngleRight, FaAngleLeft } from 'react-icons/fa';
import TelaLogin from '../pages/TelaLogin';
import Orcamento from '../pages/Orcamento';
import CheckoutPayment from '../mercadoPago/CheckoutPayment';
import AnimatedText from '../pages/AnimatedText/AnimatedText';
import AnimatedInput from '../pages/AnimatedText/AnimatedInput';

import { motion, useAnimation } from 'framer-motion';


import UserPageLayout from '../pages/UsePages/userPageLayout';



export default function Navbar() {
  const [search, setSearch] = useState('');
  const [animateExit, setAnimateExit] = useState(false);
  const searchRef = useRef('');
  const [ShowSearch, setShowSearch] = useState(false);
  const [hoveredCategoryId, setHoveredCategoryId] = useState(null);
  const [hover, setHover] = useState(null);
  const [showContats, setShowContats] = useState(null);
  const [hoverWhatsapp, setHoverWhatsapp] = useState(null);
  const [showArrowCategorias, setShowArrowCategorias] = useState(false);
  const [produtoInCategoria, setProdutoInCategoria] = useState(false);
  const [imagemRelacionados, setImagemRelacionados] = useState([])



  const {
    showTelaLogin, setShowTelaLogin,
    showOrcamento, setShowOrcamento,
    setProdutosByCategoria,
    setProdutoSearch, produtoSearch,
    setCategorias, categorias,
    animateExitOrcamento,
    scrollY, setScrollY,
    showAnimatedInput, setShowAnimatedInput,
    showUser, setShowUser,
    setShowLayoutMeusDados,
    setShowLayoutEndereco,
    setShowLayoutNewEndereco,
    setShowLayoutEditEndereco,
    setShowLayoutAlterarSenha,
    showSearchResults,
    setShowSearchResults,
    showCategories,
    setShowCategories,
    setShowCheckoutPayment,
    showCheckoutPayment,
    setOrcamentosSelecionados
  } = useContext(MyContext);

  const [windowDimensions, setWindowDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const categoriaIdRef = useRef(null);
  const [categoriaId, setCategoriaId] = useState('');
  const [activeCategory, setActiveCategory] = useState(null);

  const [hoveredCategoriaId, setHoveredCategoriaId] = useState(null);
  const navigate = useNavigate();
  const searchInputRef = useRef(null);
  const searchResultsRef = useRef(null);
  const searchPanelRef = useRef(null);

  // 2) useEffect para detectar clique fora (adicionar apenas uma vez)
  useEffect(() => {
    function handleClickOutside(e) {
      // se o clique FOR FORA do painel, fecha o painel mas NÃO zera o campo de busca
      if (searchPanelRef.current && !searchPanelRef.current.contains(e.target)) {
        setShowAnimatedInput(false);
        setShowSearch(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [/* sem dependências extras */]);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && showCategories) {
        setProdutoInCategoria(false);
        setAnimateExit(true);
        setTimeout(() => {
          setShowCategories(false);
          setAnimateExit(false);
        }, 500);
      }
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [showCategories, setShowCategories, setAnimateExit, setProdutoInCategoria]);

  useEffect(() => {
    const handleOutsideSearchClick = (e) => {
      if (!ShowSearch) return;
      if (!e.target.closest('[data-search-panel]')) {
        setShowSearch(false);
        setShowAnimatedInput(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape' && ShowSearch) {
        setShowSearch(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideSearchClick);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleOutsideSearchClick);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [ShowSearch]);







  useEffect(() => {
    const handleOutsideOrcamentoClick = (e) => {
      if (e.target.closest('[data-confirmation-modal]')) return;
      // se o orcamento não está aberto, ignora
      if (!showOrcamento) return;
      if (showCheckoutPayment) return;

      // se o clique NÃO aconteceu dentro do conteúdo do orcamento, fecha
      if (!e.target.closest('[data-orcamento-content]')) {
        setShowOrcamento(false);
      }
    };

    const handleEscape = (e) => {

      if (document.querySelector('[data-confirmation-modal]')) return;
      if (e.key === 'Escape' && showOrcamento) {
        setShowOrcamento(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideOrcamentoClick);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleOutsideOrcamentoClick);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [showOrcamento, showCheckoutPayment, setShowOrcamento]);





  useEffect(() => {
    const handleOutsideUserClick = (e) => {

      if (e.target.closest('[data-confirmation-modal]')) return;

      if (!e.target.closest('[data-user-toggle]')) {
        setShowUser(false);
        setShowTelaLogin(false);
        setHover(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        setShowUser(false);
        setShowTelaLogin(false);
        setHover(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideUserClick);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleOutsideUserClick);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [categoriaId, categoriaIdRef.current, windowDimensions.width]); // roda só uma vez



  useEffect(() => {


    const handleResize = () => {
      setWindowDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {

    if (windowDimensions.width < 968) {
      // só altera quando for realmente 0 (evita loop desnecessário)
      setScrollY(prev => (prev === 0 ? 1 : prev));
    }
    getProdutosRelacionados();
    getCategorias();

    const handleClickOutside = (event) => {
      if (
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target) &&
        searchResultsRef.current &&
        !searchResultsRef.current.contains(event.target)
      ) {
        setShowSearchResults(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [categoriaId, categoriaIdRef.current, windowDimensions.width]);
  useEffect(() => {
    if (windowDimensions.width < 968 && scrollY === 0) {
      setScrollY(1);
    }
  }, [windowDimensions.width, scrollY]);

  const getProdutosByDescricao = (desc) => {
    if (!desc || desc.trim() === '') {
      setProdutoSearch([]);
      setShowSearchResults(false);
      return;
    }

    const produtosToSearch = { descricao_produto: desc };

    const apiBase = process.env.REACT_APP_API_URL;


    fetch(`${apiBase}/api/getProdutosByDescricao`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(produtosToSearch),
    })
      .then((response) => response.json())
      .then((json) => {

        setProdutoSearch(json);

        setShowSearchResults(json.length > 0);
      })
      .catch((error) => console.error('Erro na requisição:', error));
  };

  const getProdutosRelacionados = () => {
    const toSearch = { categoria_id: categoriaIdRef.current };


    const apiBase = process.env.REACT_APP_API_URL;


    fetch(`${apiBase}/api/getProdutosRelacionados`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toSearch),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        setImagemRelacionados(json);

      })
      .catch((error) => {

      });
  };


  const getProdutos = () => {
    const toSearch = { categoria_id: categoriaIdRef.current };

    const apiBase =
      process.env.REACT_APP_API_URL ||
      `${window.location.protocol}//${window.location.hostname}:3002`;

    fetch(`${apiBase}/api/getProdutos`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toSearch),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        if (Array.isArray(json)) {
          setProdutosByCategoria(json);

        } else {
          console.error('Resposta inesperada:', json);
        }
      })
      .catch((error) => {
        console.error('Erro na requisição:', error);
      });
  };


  const getCategorias = () => {
    const toSearch = {};

    const apiBase = process.env.REACT_APP_API_URL;


    fetch(`${apiBase}/api/getCategorias`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toSearch),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((json) => {
        if (Array.isArray(json)) {
          setCategorias(json);

        } else {
          console.error('Resposta inesperada:', json);
        }
      })
      .catch((error) => {
        console.error('Erro na requisição:', error);
      });
  };

  const categoriaList = (categoria_id) => {
    categoriaIdRef.current = categoria_id;

  };

  const handleMouseEnter = (categoria_id) => {
    categoriaList(categoria_id);
    setActiveCategory(categoria_id);
    getProdutos();
  };

  const handleMouseLeave = () => {
    setActiveCategory(null);
  };

  const searchProduto = (key) => {
    setSearch(key);
    searchRef.current = key;
    getProdutosByDescricao(searchRef.current);

  };

  const openNewPage = (produto) => {
    const selectedProduct = produto.produto_id

    localStorage.setItem('produto_id', produto.produto_id);
    localStorage.setItem('categoria_id', produto.categoria_id);

    navigate(`/produto/${produto.produto_id}`);
    setShowCategories(false)
  };

  return (

    <div
      translate="no"
      style={{
        position: scrollY === 0 ? 'absolute' : 'fixed', top: 0, left: 0, width: '100%', zIndex: 10000,
      }}>


      {showOrcamento && (
        <div
          data-orcamento-content
          style={{
            position: 'fixed',
            top: 0,
            zIndex: 1000,
            display: 'flex',
            justifyContent: 'flex-end', // painel na direita
            overflow: 'hidden',
            animation: animateExitOrcamento ? 'slideOut 0.5s ease forwards' : 'slideIn 0.5s ease forwards',
          }}
        >


          <Orcamento />
        </div>
      )}
      {showCheckoutPayment && <CheckoutPayment />}


      <nav
        style={{
          display: 'flex',
          width: '100%',
        }}
      >

        <div
          style={{
            display: 'flex',
            height: '30px',
            width: '100%',
            backgroundColor: scrollY === 0
              ? 'rgba(255, 255, 255, 0)'
              : 'rgba(255, 255, 255, 1)',
            transition: 'background-color 1s ease-in-out', // <- suaviza a transição
            padding: 10,
            justifyContent: 'space-around',

          }}
        >

          {/* Inicio do Contate-nos */}
          <div style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
            onMouseEnter={() => { setShowContats(true) }}
            onMouseLeave={() => { setShowContats(false) }}
          >
            {/*<div onClick={() => window.open('https://api.whatsapp.com/send?phone=5511964442490', '_blank')} style={{ display: 'flex', flexDirection: 'row' }}>*/}
            <div onClick={() => navigate('/pedidostatuslayout')} style={{ display: 'flex', flexDirection: 'row' }}>


              <FaPlus
                style={{
                  fontSize: '12px',
                  color: showContats ? 'white' : 'black',
                  justifyContent: 'center',
                  alignSelf: 'center',
                  cursor: 'pointer',
                  transition: 'color 1s ease',
                  color: scrollY === 0 ? '#fff' : '#000'
                }}
              />
              <p style={{ alignSelf: 'center', marginLet: 5, fontSize: windowDimensions.width < 700 ? '10px' : '12px', color: scrollY === 0 ? '#fff' : '#000', cursor: 'pointer', marginLeft: 10 }} onMouseEnter={() => { setHoverWhatsapp(true) }}
              >Contate-nos</p>
            </div>




          </div>
          {/* fim do Contate-nos */}


          <div style={{}}> <AnimatedText /></div>






          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{

              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '20px'


            }}
              onClick={(e) => {
                e.stopPropagation();
                setOrcamentosSelecionados([]);
                setShowOrcamento(true);
              }}
            >
              <FaShoppingCart
                style={{
                  fontSize: '20px',
                  color: scrollY === 0 ? 'white' : 'black',
                  justifyContent: 'center',
                  alignContent: 'center',
                  cursor: 'pointer',
                  transition: 'color 1s ease',
                }}

              />
            </div>

            {(localStorage.getItem('usuario') && JSON.parse(localStorage.getItem('usuario')).usuario_id !== null) ? (
              <div
                data-user-toggle
                style={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  alignSelf: 'center',
                  marginRight: '20px',
                }}
                onClick={() => {
                  setShowUser(prev => !prev);
                  setHover(prev => !prev);
                }}
              >
                <FaUser
                  style={{
                    fontSize: '20px',
                    color: scrollY === 0 ? "white" : "black",
                    justifyContent: 'center',
                    alignContent: 'center',
                    cursor: 'pointer',
                    transition: 'color 1s ease',
                    zIndex: 999,
                  }}
                />

                {showUser && (() => {
                  const isMobile = windowDimensions.width < 968;

                  if (isMobile) {
                    // --- MOBILE: backdrop full-screen + conteúdo centralizado (mantém o comportamento que você aprovou)
                    return (
                      <div
                        style={{
                          position: 'fixed',
                          inset: 0,
                          zIndex: 9999,
                          display: 'flex',
                          height: '100%',
                          justifyContent: 'center',
                          alignItems: 'center',
                          pointerEvents: 'auto',
                        }}
                      >
                        {/* backdrop que fecha ao clicar fora */}
                        <div
                          onClick={() => {
                            setShowUser(false);
                            setShowLayoutMeusDados(false);
                            setShowLayoutEndereco(false);
                            setShowLayoutNewEndereco(false);
                            setShowLayoutEditEndereco(false);
                            setShowLayoutAlterarSenha(false);
                          }}


                          style={{
                            position: 'absolute',
                            inset: 0,
                            backgroundColor: 'rgba(0,0,0,0.35)',
                            backdropFilter: 'blur(6px)',
                            WebkitBackdropFilter: 'blur(6px)',
                          }}
                        />

                        {/* conteúdo acima do backdrop; stopPropagation para não fechar ao clicar dentro */}
                        <div
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            position: 'relative',
                            zIndex: 10000,
                            width: '100%',
                            boxSizing: 'border-box',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >

                          <UserPageLayout />
                        </div>
                      </div>
                    );
                  }

                  // --- DESKTOP: mantém exatamente o comportamento anterior (pos:absolute com top: '105%')
                  return (
                    <div
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        position: 'absolute',
                        top: '70%',
                        // left/right/transform/justifyContent não definidos para manter comportamento desktop original
                        transform: 'translateX(-30%)',
                        zIndex: 9999,
                        backgroundColor: 'transparent',
                        pointerEvents: 'auto',
                      }}
                    >

                      <UserPageLayout />
                    </div>
                  );
                })()}




              </div>
            ) : (
              <div
                data-user-toggle
                style={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  alignSelf: 'center',
                  marginRight: '20px',
                }}
                onClick={() => {
                  setShowTelaLogin(prev => !prev);
                  setHover(prev => !prev);
                }}
              >
                <FaUser
                  style={{
                    fontSize: '20px',
                    color: scrollY === 0 ? "white" : "black",
                    justifyContent: 'center',
                    alignContent: 'center',
                    cursor: 'pointer',
                    transition: 'color 1s ease',
                    zIndex: 999,
                  }}
                />

                {/* Exibe a aba dentro do mesmo contêiner */}

                {showTelaLogin && (
                  <div
                    style={{
                      height: windowDimensions.width < 968 ? '100vh' : undefined,
                      position: windowDimensions.width < 968 ? 'fixed' : 'absolute',
                      top:
                        windowDimensions.width < 968
                          ? '0%'                       // telas pequenas -> mantém comportamento atual
                          : (scrollY === 0 ? '-90%' : '-25%'),

                      left: windowDimensions.width < 968 ? 0 : undefined,
                      right: windowDimensions.width < 968 ? 0 : undefined,
                      display: windowDimensions.width < 968 ? 'flex' : undefined,
                      alignItems: windowDimensions.width < 968 ? 'center' : undefined,
                      justifyContent: windowDimensions.width < 968 ? 'center' : undefined,
                      transform:
                        windowDimensions.width < 968
                          ? 'none'                             // mantém o que já tava para telas < 968
                          : (scrollY === 0 ? 'translateX(-20%)' : 'translateX(0%)'),

                      zIndex: 9999,
                      backdropFilter: windowDimensions.width < 968 ? 'blur(8px)' : undefined,
                      WebkitBackdropFilter: windowDimensions.width < 968 ? 'blur(8px)' : undefined,
                      backgroundColor: windowDimensions.width < 968 ? 'rgba(0,0,0,0.5)' : undefined, // overlay semi-transparente em mobile
                      pointerEvents: 'auto',
                    }}
                  >
                    <div style={{ width: windowDimensions.width < 968 ? '90%' : undefined, maxWidth: '460px', margin: '0 auto' }}>
                      <TelaLogin />
                    </div>
                  </div>
                )}

              </div>
            )}




            <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <FaSearch
                style={{
                  color: scrollY === 0 ? '#fff' : '#000',
                  fontSize: '18px',
                  marginRight: '20px',
                  transition: 'color 1s ease',
                  cursor: 'pointer',
                }}
                onClick={() => setShowSearch(true)}

              />
              {ShowSearch && (
                <div
                  data-search-panel
                  ref={searchPanelRef}  // <-- adicione isto
                  style={{
                    zIndex: 9999,
                    position: windowDimensions.width < 968 ? 'fixed' : 'absolute',
                    top: windowDimensions.width < 968 ? '0%' : '130%',
                    left: windowDimensions.width < 968 ? '0%' : '0%',
                    transform: windowDimensions.width < 968 ? undefined : 'translateX(-90%)',
                    width: windowDimensions.width < 968 ? '100%' : '744px',
                    height: windowDimensions.width < 968 ? '40vh' : '380px',
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                    overflow: 'hidden',
                    boxSizing: 'border-box',
                  }}
                >

                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative', margin: '10px' }}>
                    <input
                      ref={searchInputRef}
                      type="text"
                      style={{
                        width: '83%',
                        height: '40px',
                        border: showAnimatedInput ? '1px solid rgba(128, 125, 119, 0.5)' : 'none',
                        borderBottom: '1px solid rgba(128, 125, 119, 0.5)',
                        borderRadius: '3px',
                        outline: 'none',
                        padding: '5px 5px 0',
                        lineHeight: '1',
                        transition: 'border-color 0.4s ease',
                      }}
                      onChange={(e) => searchProduto(e.target.value)}
                      onFocus={() => setShowAnimatedInput(true)}
                      value={search}
                    />

                    <motion.div
                      initial={{ opacity: 0, x: 10 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.5 }}
                      onClick={() => {
                        searchInputRef.current?.focus();
                      }}
                      style={{
                        position: 'absolute',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                        color: '#999',
                        fontStyle: 'italic',
                        zIndex: 1
                      }}
                    >
                      <AnimatedInput />
                    </motion.div>

                    <style>
                      {`
       /* agora animamos a largura do span (underline) — não do elemento pai */
       @keyframes slideInBorderCancelar { from { width: 0; } to { width: 100%; } }
       @keyframes slideOutBorderCancelar { from { width: 100%; } to { width: 0; } }

       /* deixei estas (não usadas aqui) por compatibilidade */
       @keyframes slideInBorderCategorias { from { width: 0; } to { width: 100%; } }
       @keyframes slideOutBorderCategorias { from { width: 100%; } to { width: 0; } }
     `}
                    </style>

                    <div
                      onClick={() => {
                        setShowSearch(false);
                        setShowAnimatedInput(false);
                        setProdutoSearch('0');
                        setSearch(''); // limpa o campo da busca
                      }}
                      onMouseEnter={(e) => {
                        // só anima em telas maiores que 968px
                        if (typeof window !== 'undefined' && window.innerWidth > 968) {
                          const span = e.currentTarget.querySelector('.cancel-underline');
                          if (span) {
                            span.style.animation = 'slideInBorderCancelar 0.7s forwards';
                          }
                        } else {
                          const span = e.currentTarget.querySelector('.cancel-underline');
                          if (span) {
                            span.style.animation = '';
                            span.style.width = '0';
                          }
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (typeof window !== 'undefined' && window.innerWidth > 968) {
                          const span = e.currentTarget.querySelector('.cancel-underline');
                          if (span) {
                            span.style.animation = 'slideOutBorderCancelar 0.7s forwards';
                          }
                        } else {
                          const span = e.currentTarget.querySelector('.cancel-underline');
                          if (span) {
                            span.style.animation = '';
                            span.style.width = '0';
                          }
                        }
                      }}
                      style={{ position: 'relative' }} /* para o span absoluto ter referência */
                    >
                      <p
                        style={{
                          marginLeft: '30px',
                          fontSize: '15px',
                          /* mantive a linha visual superior; se quiser que a única linha seja a animada, mude/remova isto */
                          borderBottom: 'solid 1.9px rgba(0, 0, 0, 1)',
                          transition: 'border-color 1s ease',
                          cursor: 'pointer',
                          position: 'relative' /* p será referência para o span */
                        }}
                        onMouseEnter={(e) => {
                          // espelho o mesmo comportamento (por segurança caso o mouse passe direto no <p>)
                          if (typeof window !== 'undefined' && window.innerWidth > 968) {
                            const span = e.currentTarget.querySelector('.cancel-underline');
                            if (span) span.style.animation = 'slideInBorderCancelar 0.7s forwards';
                          } else {
                            const span = e.currentTarget.querySelector('.cancel-underline');
                            if (span) {
                              span.style.animation = '';
                              span.style.width = '0';
                            }
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (typeof window !== 'undefined' && window.innerWidth > 968) {
                            const span = e.currentTarget.querySelector('.cancel-underline');
                            if (span) span.style.animation = 'slideOutBorderCancelar 0.7s forwards';
                          } else {
                            const span = e.currentTarget.querySelector('.cancel-underline');
                            if (span) {
                              span.style.animation = '';
                              span.style.width = '0';
                            }
                          }
                        }}
                      >
                        Cancelar
                        {/* underline absoluto que será animado — não afeta layout */}
                        <span
                          className="cancel-underline"
                          style={{
                            position: 'absolute',
                            left: 0,
                            bottom: '-2px', /* ajuste fino para posicionar a linha */
                            height: '2px',
                            width: '0',
                            backgroundColor: 'rgba(0,0,0,1)',
                            pointerEvents: 'none',
                          }}
                        />
                      </p>
                    </div>
                  </div>


                  <div style={{ flexDirection: 'row', display: 'flex', marginTop: '10px', width: '100%' }}>
                    <div
                      style={{
                        width: '30%',
                        marginBottom: '15px',
                        marginLeft: '15px',
                        overflowY: 'visible',
                      }}
                    >
                      <p style={{ fontSize: '12px', fontWeight: 'bold' }}>Categorias</p>
                      {categorias.map((categoria) => (
                        <div
                          key={categoria.categoria_id}
                          onClick={() => {

                            localStorage.setItem('categoria_id', categoria.categoria_id);

                            navigate(`/produtos/${categoria.categoria_id}`);
                          }}
                          onMouseEnter={() => {
                            setHoveredCategoryId(categoria.categoria_id);
                            handleMouseEnter(categoria.categoria_id);
                          }}
                          onMouseLeave={() => {
                            setHoveredCategoryId(null);
                            handleMouseLeave();
                          }}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'center',
                            width: '200px',
                            position: 'relative',
                            cursor: 'pointer',
                          }}
                        >
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <FaSearch style={{ fontSize: '12px' }} />
                              <p
                                style={{
                                  display: 'inline-flex',
                                  whiteSpace: 'nowrap',
                                  marginLeft: '5px',
                                  fontSize: '10px',
                                  borderBottom: 'solid 1.9px rgba(0, 0, 0, 1)',
                                  width: 'auto',
                                  transition: 'border-color 1s ease',
                                  cursor: 'pointer',
                                }}
                                onClick={() => {
                                  if (window.scrollY === 0 && scrollY !== 1) {
                                    setScrollY(1);
                                  }
                                  setShowAnimatedInput(false);
                                  setShowSearch(false);
                                  setProdutoSearch('0');
                                  setSearch(''); // 🔥 limpa o campo da busca
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.animation = 'slideInBorderCategorias 0.7s forwards';
                                  e.target.style.borderBottom = 'solid 1.5px rgba(0, 0, 0, 1)';
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.animation = 'slideOutBorderCategorias 0.7s forwards';
                                  e.target.style.borderBottom = 'solid 1.5px rgba(0, 0, 0, 0.5)';
                                }}
                              >
                                {categoria.categoria_nome}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {showSearchResults && produtoSearch.length > 0 && search.trim() !== '' && (
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <p style={{ fontSize: '12px', fontWeight: 'bold' }}>Produtos</p>
                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: 10, height: windowDimensions.width < 968 ? '250px' : '300px' }}>



                          <div
                            ref={searchResultsRef}
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              width: '100%',
                              maxWidth: '100%',
                              height: '100%',
                              maxHeight: windowDimensions.width < 968 ? 'calc(80vh - 140px)' : 'calc(100% - 60px)',
                              overflowY: 'auto',
                              overflowX: 'hidden',
                              zIndex: 10,
                              alignContent: 'flex-start',
                              boxSizing: 'border-box',
                              minWidth: 0,
                              padding: 6,
                              paddingBottom: 5,              // <- garante 5px entre a última linha e a borda inferior
                              gap: 5,                        // <- espaçamento uniforme entre itens (5px)
                              WebkitOverflowScrolling: 'touch',
                              overscrollBehavior: 'contain',
                              touchAction: 'pan-y',
                            }}
                          >






                            {produtoSearch.map((produto) => (
                              <div
                                key={produto.produto_id}
                                onClick={() => openNewPage(produto)}
                                style={{
                                  // trocar margin:5 por marginHorizontal (se quiser) ou zerar e confiar no gap
                                  margin: 0,                 // <- zerado para evitar margem extra na última linha
                                  marginLeft: 5,             // se quiser manter o espaçamento lateral entre colunas
                                  marginRight: 5,
                                  cursor: 'pointer',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  flex: '0 0 auto',
                                  flexShrink: 0,
                                }}
                              >
                                {produto.imagem_url && (
                                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', boxSizing: 'border-box', maxWidth: 106 }}>
                                    <img
                                      src={produto.imagem_url}
                                      alt={produto.produto_nome}
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        maxWidth: 106,
                                        maxHeight: 106,
                                        objectFit: 'cover',
                                        display: 'block',
                                      }}
                                    />
                                    <p style={{ fontSize: '10px', marginTop: '0px', textAlign: 'center', wordBreak: 'break-word' }}>{produto.produto_nome}</p>
                                  </div>
                                )}
                              </div>
                            ))}



                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

            </div>


            <>
              <div style={{ display: 'flex', flexDirection: 'row' }} onClick={() => setShowCategories(!showCategories)}>

                <FaBars

                  style={{
                    cursor: 'pointer',
                    fontSize: '18px',
                    color: scrollY === 0 ? '#fff' : '#000',
                    alignSelf: 'center',
                    transition: 'color 1s ease',

                  }}
                />

              </div>



              {showCategories && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0, left: 0,
                    width: '100vw', height: '100vh',
                    backdropFilter: 'blur(5px)',
                    backgroundColor: 'rgba(0,0,0,0.2)',
                    zIndex: 9998,             // abaixo do menu
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setProdutoInCategoria(false)
                    setAnimateExit(true);
                    setTimeout(() => {
                      setShowCategories(false);
                      setAnimateExit(false);
                    }, 500);
                  }}
                >


                  <div
                    style={{
                      position: 'absolute',
                      top: '0px',
                      width: windowDimensions.width < 968 ? '100%' : '30%',
                      height: '1000px',
                      right: '0px',
                      backgroundColor: '#fff',
                      zIndex: 10000,
                      animation: animateExit
                        ? 'slideOut 0.5s ease forwards'
                        : 'slideIn 0.5s ease forwards',
                    }}
                    onClick={(e) => e.stopPropagation()} // evita que cliques dentro do painel fechem o overlay
                  >



                    <style>
                      {`
                                    @keyframes slideIn {
                                   from { transform: translateX(100%); }
                                   to { transform: translateX(0%); }
                                  }
                                 @keyframes slideOut {
                                   from { transform: translateX(0%); }
                                   to { transform: translateX(100%); }
                                  }
                                  @keyframes slideInCategoria {
                                   from {
                                     transform: translateX(15%);
                                     opacity: 1;
                                  }
                                   to {
                                     transform: translateX(0%);
                                    opacity: 0;
                                   }
                                 }

                                 @keyframes slideOutCategoria {
                                   from {
                                     transform: translateX(0%);
                                     opacity: 0;
                                   }
                                   to {
                                     transform: translateX(15%);
                                     opacity: 1;
                                   }                      
                                 }
                                   @keyframes slideInBorder {
                                    from { width: 0; }
                                    to { width: 8%; }
                                  }
                                  @keyframes slideOutBorder {
                                    from { width: 8%; }
                                    to { width: 0; }
                                  }
                                      @keyframes slideInProduto {
                                    from {
                                      
                                      transform: translateX(20px);
                                    }
                                    to {
                                      
                                      transform: translateX(0);
                                    }
                                  }
                              
                                 @keyframes slideOutProduto {
                                    from {
                                     
                                      transform: translateX(0);
                                    }
                                    to {
                                     
                                      transform: translateX(20px);
                                    }
                                   }                   
                               `}
                    </style>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        position: 'absolute',
                        right: '0px',
                        backgroundColor: 'white',
                      }}
                      onClick={() => {
                        setProdutoInCategoria(false)
                        setAnimateExit(true);
                        setTimeout(() => {
                          setShowCategories(false);
                          setAnimateExit(false);
                        }, 500);
                      }}
                    >
                      <FaTimes
                        style={{
                          cursor: 'pointer',
                          fontSize: '20px',
                          color: '#fff',
                          margin: '20px',
                          borderRadius: '100px',
                          backgroundColor: '#000',
                          padding: '10px'
                        }}
                      />

                    </div>
                    {produtoInCategoria ? (
                      <div
                        style={{
                          listStyle: 'none',
                          padding: '0',
                          marginTop: '80px',
                          marginLeft: '50px',
                          /* limite a altura para permitir scroll vertical quando houver muitos itens */
                          maxHeight: 'calc(100vh - 120px)', // ajusta conforme header/offset; mantém na viewport
                          overflowY: 'auto',                 // habilita scroll vertical
                          WebkitOverflowScrolling: 'touch',  // momentum scrolling no iOS
                          touchAction: 'pan-y',              // garante pan vertical por touch
                          animation: 'slideInProduto 1s ease forwards',
                        }}
                      >
                        <div
                          style={{
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '5px',
                            top: 0
                          }}
                          onClick={() => setProdutoInCategoria(false)}
                        >
                          <FaAngleLeft style={{ margin: '0', fontSize: '15px' }} />
                          <p
                            style={{
                              marginTop: '14px',
                              alignSelf: 'center',
                              fontSize: '15px',
                              borderBottom: 'solid 1.9px rgba(0, 0, 0, 1)',
                              width: '0%',
                              transition: 'border-color 1s ease',
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.animation = 'slideInBorder 0.7s forwards';
                              e.target.style.borderBottom = 'solid 1.5px rgba(0, 0, 0, 1)';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.animation = 'slideOutBorder 0.7s forwards';
                              e.target.style.borderBottom = 'solid 1.5px rgba(0, 0, 0, 0.5)';
                            }}
                          >
                            voltar
                          </p>
                        </div>

                        <h2 style={{ fontWeight: 'normal', marginBottom: '60px' }}>
                          {imagemRelacionados?.[0]?.categoria_nome ?? '— sem categoria —'}
                        </h2>

                        {/* container das imagens: agora com altura limitada e scroll se necessário */}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            gap: '10px',
                            /* permitir scroll dentro deste bloco caso haja muitas imagens */
                            maxHeight: '80%', // deixa espaço para header/título; ajusta se precisar
                            overflowY: 'auto',
                            WebkitOverflowScrolling: 'touch',
                            touchAction: 'pan-y',
                            zIndex: 9000,
                            paddingRight: 8, // evita que a scrollbar sobreponha conteúdo visualmente
                          }}
                        >
                          {imagemRelacionados.map((item) => {
                            return (
                              <div
                                key={item.produto_id ?? item.imagem_url}
                                style={{
                                  flex: windowDimensions?.width < 968
                                    ? '0 0 calc(50% - 10px)'
                                    : '0 0 182px',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'stretch',
                                  boxSizing: 'border-box',
                                }}
                              >
                                <img
                                  src={item.imagem_url}
                                  alt={item.produto_nome}
                                  style={{
                                    width: '100%',
                                    aspectRatio: '4 / 3',
                                    height: 'auto',
                                    objectFit: 'cover',
                                    transition: 'transform 0.3s ease',
                                    display: 'block',
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => {
                                    openNewPage(item);
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(0.95)';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                  }}
                                />

                                <p
                                  style={{
                                    margin: '8px 0 0 0',
                                    textAlign: 'left',
                                    fontSize: '12px',
                                  }}
                                >
                                  {item.produto_nome}
                                </p>

                                {item.preco_inicial != null &&
                                  item.preco_inicial !== '' && (
                                    <div
                                      style={{
                                        marginTop: 4,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: 8,
                                        fontSize: '10px',
                                        color: '#555',
                                      }}
                                    >
                                      <span>
                                        {Number(item.preco_inicial).toLocaleString('pt-BR', {
                                          style: 'currency',
                                          currency: 'BRL',
                                        })}
                                      </span>

                                      {item.tamanho_inicial_cm != null && (
                                        <span>
                                          {item.tamanho_inicial_cm} cm
                                        </span>
                                      )}
                                    </div>
                                  )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      <ul
                        style={{
                          listStyle: 'none',
                          padding: '0',
                          marginTop: '80px',
                          marginLeft: '50px',
                          /* permite scroll caso haja muitas categorias */
                          maxHeight: 'calc(100vh - 120px)',
                          overflowY: 'auto',
                          WebkitOverflowScrolling: 'touch',
                          touchAction: 'pan-y',
                          animation: 'slideOutProduto 1s ease forwards',
                        }}
                      >
                        {categorias.map((categoria) => (
                          <li
                            key={categoria.categoria_id}
                            style={{
                              padding: '10px',
                              cursor: 'pointer',
                              color: '#000',
                              borderBottom: 'none',
                              marginBottom: '0px',
                              fontSize: '20px',
                              transition: 'all 0.5s ease',
                              fontFamily: '"Playfair Display", serif',
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                            onClick={() => {
                              setProdutoInCategoria(true);
                              handleMouseEnter(categoria.categoria_id)
                            }}
                            onMouseEnter={() => {
                              setHoveredCategoriaId(categoria.categoria_id);
                              setShowArrowCategorias(true);
                            }}
                            onMouseLeave={() => {
                              setHoveredCategoriaId(categoria.categoria_id);
                              setShowArrowCategorias(false);
                            }}
                          >
                            {categoria.categoria_nome}
                            {hoveredCategoriaId === categoria.categoria_id && (
                              <FaAngleRight
                                style={{
                                  margin: '0px',
                                  fontSize: '14px',
                                  marginLeft: '8px',
                                  animation: showArrowCategorias
                                    ? 'slideOutCategoria 0.8s ease forwards'
                                    : 'slideInCategoria 0.8s ease forwards',
                                }}
                              />
                            )}
                          </li>
                        ))}
                      </ul>
                    )}


                  </div>
                </div>
              )}


            </>
          </div>
        </div>

      </nav >



      <div>

      </div>
    </div >
  );
}
